import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ObjectUtilsService {

  constructor() { }

  generateLangs(lstAvailableLangCodes:string[], object:any){  
    if(!object.langs){
      object.langs = {};
    }
    lstAvailableLangCodes.forEach(langCode => {
      object.langs[langCode] = (object.langs && object.langs[langCode] ? object.langs[langCode] : {});
    });

    return object;
  }
}
